// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__JD+ry","form":"LoginPage_form__pgav1"};